import './paedml-card.tag'
import './paedml-modal-pw.tag'
import './paedml-icon.tag'
import './paedml-icon-modal.tag'
import './paedml-modal-info-meineschueler.tag'
import './paedml-modal-handout.tag'
import './paedml-modal-add-to-proj.tag'

<paedml-card-meineschueler>
  <paedml-card config={opts.config} perm={opts.perm} siblings={opts.siblings}>
    <virtual if="{selectedExactlyOne()}">
      <paedml-icon-modal icon="fas-barcode" target="#{prefix}-see-modal" title="Schüler*in-Info ansehen" />
      <paedml-modal-info-meineschueler prefix="{prefix}-see" edit={true} selectedrowsfunc={getSelectedRows}
        heading="{config.contentTitle}: Info" opname="OK" api={restApi} />
    </virtual>

    <virtual if="{selectedOneOrMore()}">
      <paedml-icon-modal icon="passwort-bearbeiten" target="#{prefix}-pw-modal" title="Kennwort ändern" />
      <paedml-modal-pw prefix="{prefix}-pw" heading={config.contentTitle} selectedrowsfunc={getSelectedRows}
        variant="student" preset="{config.preset ? config.preset.password : {}}" api={restApi} 
        indexschulart={parent.indexschulart} />
    </virtual>
    
    <virtual if="{selectedOneOrMore()}">
      <paedml-icon-modal icon="fas-file-upload" target="#{prefix}-handout-modal" title="Dateien austeilen" />
      <paedml-modal-handout prefix="{prefix}-handout" variant="student" selectedrowsfunc={getSelectedRows}
        patient="{{singular: 'Schüler', plural: 'Schüler*innen'}}"
        heading="{config.contentTitle}: Dateien austeilen" opname="Dateien austeilen" api={restApi} />
    </virtual>
  
    <virtual if="{selectedOneOrMore()}">
      <paedml-icon-modal icon="fas-project-diagram" target="#{prefix}-addtoproj-modal" title="Zum Projekt hinzufügen" />
      <paedml-modal-add-to-proj prefix="{prefix}-addtoproj" selectedrowsfunc={getSelectedRows}
        patient="{{singular: 'Schüler', plural: 'Schüler*innen'}}"
        heading="{config.contentTitle}: Zum Projekt hinzufügen" opname="Zum Projekt hinzufügen" api={restApi} />
    </virtual>
  
  </paedml-card>
  <script>
     this.deactivatedcol = opts.config.custom.deactivatedcol
    this.indexschulart = opts.config.custom.indexschulart
  </script>
</paedml-card-meineschueler>
